export class ProductFormVariantSelect {
    constructor(product_json, section_id, enable_history) {
        this.product_json = product_json;
        this.product_id = this.product_json.id;
        this.section_id = section_id;
        this.enable_history = enable_history;
        this.stock_rules = {};
        this.master_select = null;
        this.product_form = null;
        this.quantity_selector = null;
        this.master_select_prefix = 'product-id';
        this.radio = '.option-radios-wrapper input[type=radio]';
        this.form = `form[action='${window.QF.cartRoutes.cart_add_url}']`;

        this.init();
    }

    init() {
        this.master_select = document.querySelector('#' + this.master_select_prefix + '-' + this.section_id + '-' + this.product_id);
        this.product_form = this.master_select.closest(this.form);
        this.quantity_selector = this.product_form?.querySelector('[quantity-select]');
        this.subtotal_el = this.product_form.querySelector('[product-sub-total]');
        this.maxtotal_el = this.product_form.querySelector('[product-max-total]');
        this.savingtotal_el = this.product_form.querySelector('[product-saving-total]');
        this.add_to_cart = this.product_form.querySelector('[add-to-cart]');
        this.add_to_cart_label = this.product_form.querySelector('[add-to-cart-label]');
        this.add_to_cart_price = this.product_form.querySelector('[add-to-cart-price]');

        this.mobile_subtotal_el = this.product_form.querySelector('[mobile-product-sub-total]');
        this.mobile_add_to_cart = this.product_form.querySelector('[mobile-add-to-cart]');
        this.mobile_add_to_cart_label = this.product_form.querySelector('[mobile-add-to-cart-label]');
        this.mobile_add_to_cart_price = this.product_form.querySelector('[mobile-add-to-cart-price]');

        this.gallery_slides = document.querySelectorAll("[main-gallery] .main-swiper-slide");
        this.text_add_to_cart = this.product_form.dataset.addToCart;
        this.text_sold_out = this.product_form.dataset.soldOut;
        this.text_unavailable = this.product_form.dataset.unavailable;
        this.money_format = this.product_form.dataset.moneyFormat;
        this.stockRules();
        this.shopifyOptionSelect();

        //Selecting the first available variant
        setTimeout(() => {
            this.forceFirstInStockVariant();
        }, 100);

        this.radiosOnChange();
        this.bindOptionHoverEvents();
		this.populateInitialOptionNames();
        this.bindRelatedColoursSwatches();

    }

    stockRules() {
        const select_options = this.master_select.querySelectorAll('option');
        if (select_options.length === 0) {
            console.error("Select options not found.");
            return;
        }
        select_options.forEach((option) => {
            if (option.dataset.inventoryManagement === "shopify" && option.dataset.inventoryPolicy === "deny") {
                this.stock_rules[option.value] = option.dataset.inventoryQuantity;
            } else {
                this.stock_rules[option.value] = Number.MAX_SAFE_INTEGER;
            }
        });
    }


    setVariantPrice(variant) {
        if (!this.subtotal_el) {
            return;
        }
        const money_format = this.subtotal_el.dataset.moneyFormat;
        this.subtotal_el.setAttribute("data-variant-price", variant.price);
        this.subtotal_el.innerHTML = Shopify.formatMoney(variant.price, money_format);

        if (!this.mobile_subtotal_el) {
            return;
        }
        const mobile_money_format = this.mobile_subtotal_el.dataset.moneyFormat;
        this.mobile_subtotal_el.setAttribute("data-variant-price", variant.price);
        this.mobile_subtotal_el.innerHTML = Shopify.formatMoney(variant.price, mobile_money_format);
    }

    setSubmitButtonState(availability) {
        const submit = this.add_to_cart;
        const label = this.add_to_cart_label;
        const price = this.add_to_cart_price;

        const mobile_submit = this.mobile_add_to_cart;
        const mobile_label = this.mobile_add_to_cart_label;
        const mobile_price = this.mobile_add_to_cart_price;

        const ADD_TO_CART = this.text_add_to_cart;
        const SOLD_OUT = this.text_sold_out;
        const UNAVAILABLE = this.text_unavailable;

        if (!submit) {
            return;
        }

        if (!mobile_submit) {
            return;
        }

        if (availability === true || availability === "true") {
            submit.value = ADD_TO_CART;
            submit.innerHTML = ADD_TO_CART;
            submit.removeAttribute("disabled");
            label.classList.remove("disabled");
            price.style.display = 'block';

            mobile_submit.value = ADD_TO_CART;
            mobile_submit.innerHTML = ADD_TO_CART;
            mobile_submit.removeAttribute("disabled");
            mobile_label.classList.remove("disabled");
            mobile_price.style.display = 'block';
        } else if (availability === "unavailable") {
            submit.value = UNAVAILABLE;
            submit.innerHTML = UNAVAILABLE;
            submit.setAttribute("disabled", "");
            label.classList.add("disabled");
            price.style.display = 'none';

            mobile_submit.value = UNAVAILABLE;
            mobile_submit.innerHTML = UNAVAILABLE;
            mobile_submit.setAttribute("disabled", "");
            mobile_label.classList.add("disabled");
            mobile_price.style.display = 'none';
        } else {
            submit.value = SOLD_OUT;
            submit.innerHTML = SOLD_OUT;
            submit.setAttribute("disabled", "");
            label.classList.add("disabled");
            price.style.display = 'none';

            mobile_submit.value = SOLD_OUT;
            mobile_submit.innerHTML = SOLD_OUT;
            mobile_submit.setAttribute("disabled", "");
            mobile_label.classList.add("disabled");
            mobile_price.style.display = 'none';
        }
    }

    setQuantityVisibility(availability) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_wrapper = this.quantity_selector.closest('.quantity-wrapper');
        if (!quantity_wrapper) {
            return;
        }

        if (availability === "unavailable" || availability === false) {
            quantity_wrapper.style.display = "none";
        } else {
            quantity_wrapper.style.display = "flex";
        }
    }

    setQuantityStock(variant) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_input = this.quantity_selector.querySelector('input');
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }

        const max_stock = this.stock_rules[variant.id];
        quantity_input.max = max_stock;
    }

    setQuantityRules(quantity_rule) {
        if (!this.quantity_selector) {
            console.warn("Quantity selector not found.");
            return;
        }
    
        const quantity_input = this.quantity_selector.querySelector('input');
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }
    
        const quantity_number_el = this.quantity_selector.querySelector('[quantity]');
        if (!quantity_number_el) {
            console.error("Quantity number element not found.");
            return;
        }
    
        // If quantity_rule is missing, extract values from the input element
        const min = quantity_rule?.min || quantity_input.getAttribute("min") || 1;
        const max = quantity_rule?.max || quantity_input.getAttribute("max") || 10000000;
        const step = quantity_rule?.step || quantity_input.getAttribute("step") || 1;
    
        quantity_input.min = quantity_input.value = quantity_number_el.innerHTML = min;
        quantity_input.max = max;
        quantity_input.step = step;
    }         

    checkRadios(selector) {
        const selects = selector.selectors;
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length > 1) {
            selects.forEach((select) => {
                const select_index = select.index + 1;
                const selected_option_index = select.element.selectedIndex;
                const radio_to_check = this.product_form.querySelector(`.radio-option[data-option="${select_index}"] input[data-index="${selected_option_index}"]`);
                if (radio_to_check) {
                    radio_to_check.checked = true;
                    radio_to_check.setAttribute("checked", true);
                } else {
                    console.log(`Radio button for select ${select_index} not found.`);
                }
            });
        }
    }

    // updateSelectedColor() {
    //     const selectedColorRadio = this.product_form.querySelector('.colour-radio-option input[type="radio"]:checked');
    //     const colorNameSpan = this.product_form.querySelector('span[variant-colour-name]');
    
    //     if (selectedColorRadio && colorNameSpan) {
    //         colorNameSpan.textContent = selectedColorRadio.value;
    //     }
    // }

    radiosOnChange() {
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length > 0) {
            radios.forEach(radio => {
                radio.addEventListener('change', () => {
                    const option_index = radio.closest('.radio-option').dataset.option;
                    const option_value = radio.value;
                    const select = this.product_form.querySelector(`select[data-option='option${option_index}']`);
    
                    if (select) {
                        select.value = option_value;
                        const event = new Event('change');
                        select.dispatchEvent(event);
                    } else {
                        console.error(`Select element for radio ${option_index} not found.`);
                    }

                    // Update the selected option span on radio change
                    const radioOption = radio.closest('.radio-option');
                    if (radioOption) {
                        const selectedOptionSpan = radioOption.querySelector('[data-selected-option]');
                        if (selectedOptionSpan) {
                        const label = radioOption.querySelector(`label[for="${radio.id}"]`);
                        if (label) {
                            selectedOptionSpan.textContent = label.textContent.trim();
                        }
                        }
                    }

                    //this.updateSelectedColor();
                });
            });
        }
    }

    populateInitialOptionNames() {
		const radioOptions = this.product_form.querySelectorAll('.radio-option');
		radioOptions.forEach((radioOption) => {
			const selectedOptionSpan = radioOption.querySelector('[data-selected-option]');
			if (selectedOptionSpan) {
				const checkedRadio = radioOption.querySelector('input[type="radio"]:checked');
				if (checkedRadio) {
					const checkedLabel = radioOption.querySelector(`label[for="${checkedRadio.id}"]`);
					selectedOptionSpan.textContent = checkedLabel ? checkedLabel.textContent.trim() : "";
				} else {
					// If no radio is checked, default to the first radio's label text
					const firstRadio = radioOption.querySelector('input[type="radio"]');
					if (firstRadio) {
						const firstLabel = radioOption.querySelector(`label[for="${firstRadio.id}"]`);
						selectedOptionSpan.textContent = firstLabel ? firstLabel.textContent.trim() : "";
					}
				}
			}
		});
	}

	bindOptionHoverEvents() {
        // Bind mouseenter on inputs to update the span immediately.
        const inputs = this.product_form.querySelectorAll('.variant-radios input');
        inputs.forEach(input => {
            input.addEventListener('mouseenter', () => {
                const radioOption = input.closest('.radio-option');
                if (radioOption) {
                    const selectedOptionSpan = radioOption.querySelector('[data-selected-option]');
                    if (selectedOptionSpan) {
                        // Update to the hovered option’s label text.
                        const correspondingLabel = radioOption.querySelector(`label[for="${input.id}"]`);
                        if (correspondingLabel) {
                            selectedOptionSpan.textContent = correspondingLabel.textContent.trim();
                        }
                    }
                }
            });
        });
    
        // Bind mouseleave on each radio-option container to revert to the selected radio.
        const radioOptions = this.product_form.querySelectorAll('.radio-option');
        radioOptions.forEach(radioOption => {
            radioOption.addEventListener('mouseleave', () => {
                const selectedOptionSpan = radioOption.querySelector('[data-selected-option]');
                if (selectedOptionSpan) {
                    // Find the currently checked radio within this option.
                    const checkedRadio = radioOption.querySelector('input[type="radio"]:checked');
                    if (checkedRadio) {
                        const correspondingLabel = radioOption.querySelector(`label[for="${checkedRadio.id}"]`);
                        selectedOptionSpan.textContent = correspondingLabel
                            ? correspondingLabel.textContent.trim()
                            : "";
                    } else {
                        // Fallback if no radio is selected.
                        selectedOptionSpan.textContent = "";
                    }
                }
            });
        });
    }     

    bindRelatedColoursSwatches() {
        const container = document.querySelector('.product-related-colours');
        if (!container) return;
        
        const selectedOptionSpan = container.querySelector('[data-selected-option]');
        const swatches = container.querySelectorAll('.swatches .swatch');
    
        swatches.forEach((swatch) => {
            swatch.addEventListener('mouseenter', () => {
                const title = swatch.getAttribute('data-title') || "";
                selectedOptionSpan.textContent = title;
            });
        });
    
        // When the mouse leaves the entire swatches container,
        // revert the title to the active swatch.
        const swatchesContainer = container.querySelector('.swatches');
        if (swatchesContainer) {
            swatchesContainer.addEventListener('mouseleave', () => {
                const activeSwatch = container.querySelector('.swatch.active');
                if (activeSwatch) {
                    const title = activeSwatch.getAttribute('data-title') || "";
                    selectedOptionSpan.textContent = title;
                } else {
                    // Optionally clear or leave unchanged
                    selectedOptionSpan.textContent = "";
                }
            });
        }
    }

    variantImageChange(variant) {
        if (!this.gallery_slides) {
          return;
        }
        const if_card = this.product_form.getAttribute('data-card');
        if (if_card == "true") {
            return;
        }
        const is_quickview = this.product_form.closest(".quick-view-modal") ? true : false;
        this.gallery_slides.forEach((slide) => {
            const slide_id = slide.dataset.id;
            const slide_index = slide.dataset.index;
            if (!slide_id) {
                return;
            }
            const slide_variant_ids = slide_id.split(',');
            if (slide_variant_ids.includes(variant.id.toString())) {
                if (is_quickview) {
                    if (window.gallery_swiper) {
                        window.gallery_swiper.slideTo(slide_index, 500);
                    }
                } else {
                    mainSwiper.slideTo(slide_index,500);
                }
            }
        });
    }

    selectCallback(variant, selector) {
        // AVAILABILITY STATES
        const AVAILABILITY_AVAILABLE = true;
        const AVAILABILITY_UNAVAILABLE = "unavailable";
        const AVAILABILITY_SOLD_OUT = "sold_out";

        if (!variant) {
            this.setSubmitButtonState(AVAILABILITY_UNAVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_UNAVAILABLE);
            return;
        }

        if (variant.available) {
            this.setSubmitButtonState(AVAILABILITY_AVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_AVAILABLE);
        } else {
            this.setSubmitButtonState(AVAILABILITY_SOLD_OUT);
            this.setQuantityVisibility(AVAILABILITY_SOLD_OUT);
        }

        this.checkRadios(selector);
        this.setQuantityStock(variant);

        // Check if quantity_rule exists before passing it
        if (variant.quantity_rule) {
            console.log("✅ Passing quantity_rule to setQuantityRules:", variant.quantity_rule);
            this.setQuantityRules(variant.quantity_rule);
        } else {
            console.warn("⚠️ Variant missing quantity_rule. Using default.");
            this.setQuantityRules({});
        }

        this.setVariantPrice(variant);
        this.variantImageChange(variant);
    }

    shopifyOptionSelect() {
        new Shopify.OptionSelectors(this.master_select_prefix + '-' + this.section_id + '-' + this.product_id, {
            product: this.product_json,
            onVariantSelected: this.selectCallback.bind(this),
            enableHistoryState: this.enable_history
        });
    }

    forceFirstInStockVariant() {
        const firstAvailable = this.product_json.variants.find(v => v.available);
        if (!firstAvailable) return;
    
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length === 0) return;
    
        let currentlySelectedInput = this.product_form.querySelector(`${this.radio}:checked`);
        let currentlySelectedValue = currentlySelectedInput?.value?.trim().toLowerCase();
    
        // Check if the current selection is a valid, in-stock variant
        const currentVariant = this.product_json.variants.find(v => {
            return v.available && v.option1.trim().toLowerCase() === currentlySelectedValue;
        });
    
        if (currentVariant) {
            // 👌 Valid and in stock — no override needed
            return;
        }
    
        // Otherwise, find and select the first in-stock variant
        let matchedInput = null;
        radios.forEach((input) => {
            const inputValue = input.value.trim().toLowerCase();
            const variantValue = firstAvailable.option1.trim().toLowerCase();
            if (inputValue === variantValue) {
                matchedInput = input;
            }
        });
    
        if (matchedInput && !matchedInput.checked) {
            const label = this.product_form.querySelector(`label[for="${matchedInput.id}"]`);
            if (label) {
                label.click(); // Triggers associated change events via label
            } else {
                matchedInput.checked = true;
                matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }
    

}